import { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import "./NewInSalesroute.css";

/* ---------- Icons ---------- */

const RocketIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 32 32" fill="none" aria-hidden="true">
    <path d="M5.99967 22C3.99967 23.68 3.33301 28.6667 3.33301 28.6667C3.33301 28.6667 8.31967 28 9.99967 26C10.9463 24.88 10.933 23.16 9.87967 22.12C9.36142 21.6253 8.67873 21.3395 7.96264 21.3174C7.24655 21.2952 6.54751 21.5383 5.99967 22Z" stroke="white" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16 20L12 16C12.7095 14.1592 13.6029 12.3947 14.6667 10.7333C16.2202 8.2493 18.3835 6.20405 20.9507 4.79211C23.5178 3.38016 26.4036 2.64848 29.3333 2.66665C29.3333 6.29332 28.2933 12.6667 21.3333 17.3333C19.6492 18.3983 17.8625 19.2916 16 20Z" stroke="white" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.9997 16H5.33301C5.33301 16 6.06634 11.96 7.99967 10.6667C10.1597 9.22667 14.6663 10.6667 14.6663 10.6667" stroke="white" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16 20V26.6667C16 26.6667 20.04 25.9333 21.3333 24C22.7733 21.84 21.3333 17.3333 21.3333 17.3333" stroke="white" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const SparkleIcon = ({ size = 18 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <path d="M8.28086 12.9166C8.20647 12.6283 8.05615 12.3651 7.84555 12.1545C7.63494 11.9439 7.37176 11.7935 7.08336 11.7191L1.97086 10.4008C1.88364 10.3761 1.80687 10.3235 1.75221 10.2512C1.69754 10.1788 1.66797 10.0907 1.66797 9.99998C1.66797 9.90931 1.69754 9.82112 1.75221 9.74878C1.80687 9.67644 1.88364 9.62391 1.97086 9.59915L7.08336 8.27998C7.37166 8.20566 7.63477 8.05546 7.84537 7.84502C8.05596 7.63457 8.20634 7.37156 8.28086 7.08332L9.5992 1.97082C9.6237 1.88325 9.67618 1.8061 9.74863 1.75115C9.82108 1.69619 9.90951 1.66644 10.0004 1.66644C10.0914 1.66644 10.1798 1.69619 10.2523 1.75115C10.3247 1.8061 10.3772 1.88325 10.4017 1.97082L11.7192 7.08332C11.7936 7.37171 11.9439 7.6349 12.1545 7.8455C12.3651 8.0561 12.6283 8.20642 12.9167 8.28082L18.0292 9.59832C18.1171 9.62257 18.1946 9.67499 18.2499 9.74755C18.3052 9.8201 18.3351 9.90878 18.3351 9.99998C18.3351 10.0912 18.3052 10.1799 18.2499 10.2524C18.1946 10.325 18.1171 10.3774 18.0292 10.4016L12.9167 11.7191C12.6283 11.7935 12.3651 11.9439 12.1545 12.1545C11.9439 12.3651 11.7936 12.6283 11.7192 12.9166L10.4009 18.0292C10.3764 18.1167 10.3239 18.1939 10.2514 18.2488C10.179 18.3038 10.0905 18.3335 9.99961 18.3335C9.90868 18.3335 9.82025 18.3038 9.7478 18.2488C9.67535 18.1939 9.62287 18.1167 9.59836 18.0292L8.28086 12.9166Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const BoltIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <path d="M3.33325 11.6667C3.17555 11.6672 3.02094 11.623 2.88737 11.5391C2.75381 11.4553 2.64677 11.3353 2.5787 11.193C2.51063 11.0508 2.48432 10.8921 2.50283 10.7355C2.52133 10.5789 2.5839 10.4308 2.68325 10.3083L10.9332 1.80833C10.9951 1.73689 11.0795 1.68862 11.1724 1.67144C11.2653 1.65425 11.3613 1.66917 11.4447 1.71375C11.528 1.75832 11.5937 1.82991 11.631 1.91675C11.6683 2.00359 11.675 2.10053 11.6499 2.19166L10.0499 7.20833C10.0027 7.3346 9.98689 7.47043 10.0037 7.60417C10.0206 7.7379 10.0696 7.86556 10.1467 7.97618C10.2237 8.0868 10.3264 8.17709 10.446 8.23929C10.5656 8.3015 10.6985 8.33377 10.8332 8.33333H16.6666C16.8243 8.33279 16.9789 8.37701 17.1124 8.46084C17.246 8.54468 17.3531 8.6647 17.4211 8.80695C17.4892 8.94919 17.5155 9.10784 17.497 9.26444C17.4785 9.42105 17.4159 9.56919 17.3166 9.69166L9.06658 18.1917C9.00469 18.2631 8.92036 18.3114 8.82743 18.3285C8.73449 18.3457 8.63847 18.3308 8.55514 18.2862C8.4718 18.2417 8.40609 18.1701 8.3688 18.0832C8.33151 17.9964 8.32485 17.8995 8.34991 17.8083L9.94991 12.7917C9.99709 12.6654 10.0129 12.5296 9.99609 12.3958C9.97924 12.2621 9.9302 12.1344 9.85317 12.0238C9.77614 11.9132 9.67343 11.8229 9.55385 11.7607C9.43426 11.6985 9.30137 11.6662 9.16658 11.6667H3.33325Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CheckIcon = ({ size = 18, strokeWidth = 1.6 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="M13.3337 4L6.00033 11.3333L2.66699 8" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <path d="M16.6663 8.33335C16.6663 12.4942 12.0505 16.8275 10.5005 18.1659C10.3561 18.2744 10.1803 18.3331 9.99967 18.3331C9.81901 18.3331 9.64324 18.2744 9.49884 18.1659C7.94884 16.8275 3.33301 12.4942 3.33301 8.33335C3.33301 6.56524 4.03539 4.86955 5.28563 3.61931C6.53587 2.36907 8.23156 1.66669 9.99967 1.66669C11.7678 1.66669 13.4635 2.36907 14.7137 3.61931C15.964 4.86955 16.6663 6.56524 16.6663 8.33335Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10 10.8333C11.3807 10.8333 12.5 9.71402 12.5 8.33331C12.5 6.9526 11.3807 5.83331 10 5.83331C8.61929 5.83331 7.5 6.9526 7.5 8.33331C7.5 9.71402 8.61929 10.8333 10 10.8333Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ChevronIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

SparkleIcon.propTypes = { size: PropTypes.number };
CheckIcon.propTypes = { size: PropTypes.number, strokeWidth: PropTypes.number };

/* ---------- Config ---------- */

const TABS = [
  { key: "all", label: "All Updates", Icon: SparkleIcon, tone: "all" },
  { key: "feature", label: "New Features", Icon: BoltIcon, tone: "feature" },
  { key: "improvement", label: "Improvements", Icon: SparkleIcon, tone: "improvement" },
  { key: "fix", label: "Fixes", Icon: CheckIcon, tone: "fix" },
];

const BADGES = {
  feature: "NEW",
  improvement: "IMPROVED",
  fix: "FIXED",
};

const TypeIcon = ({ type }) => {
  if (type === "feature") return <PinIcon />;
  if (type === "improvement") return <SparkleIcon />;
  return <CheckIcon />;
};
TypeIcon.propTypes = { type: PropTypes.string.isRequired };

/* ---------- Component ---------- */

const NewInSalesroute = ({ isOpen, onClose, release }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("all");
  const [expandedKey, setExpandedKey] = useState(null);
  const [expandableKeys, setExpandableKeys] = useState({});
  const descRefs = useRef({});
  const listRef = useRef(null);

  const items = useMemo(() => {
    if (!release) return [];
    const { features = [], improvements = [], bug_fixes = [] } = release;
    return [
      ...features.map((f) => ({
        key: `feature-${f.id}`,
        type: "feature",
        title: f.name,
        description: f.description,
        image: f.image,
      })),
      ...improvements.map((i) => ({
        key: `improvement-${i.id}`,
        type: "improvement",
        title: i.text,
        description: i.description,
      })),
      ...bug_fixes.map((b) => ({
        key: `fix-${b.id}`,
        type: "fix",
        title: b.text,
        description: b.description,
      })),
    ];
  }, [release]);

  const counts = useMemo(
    () => ({
      all: items.length,
      feature: items.filter((i) => i.type === "feature").length,
      improvement: items.filter((i) => i.type === "improvement").length,
      fix: items.filter((i) => i.type === "fix").length,
    }),
    [items]
  );

  // Fall back to "all" if the selected category has nothing in this release
  const currentTab = counts[activeTab] > 0 ? activeTab : "all";
  const visibleItems = currentTab === "all" ? items : items.filter((i) => i.type === currentTab);
  const currentTabConfig = TABS.find((tab) => tab.key === currentTab);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isOpen, onClose]);

  useLayoutEffect(() => {
    if (!isOpen || !release) return undefined;

    const checkOverflow = () => {
      const next = {};
      visibleItems.forEach((item) => {
        const el = descRefs.current[item.key];
        if (!el || !item.description) {
          next[item.key] = false;
          return;
        }
        const lineHeight = parseFloat(window.getComputedStyle(el).lineHeight) || 20;
        const isItemExpanded = expandedKey === item.key;
        next[item.key] = isItemExpanded
          ? el.scrollHeight > Math.ceil(lineHeight * 1.5)
          : el.scrollHeight > el.clientHeight + 1;
      });
      setExpandableKeys((prev) => {
        const prevKeys = Object.keys(prev);
        const nextKeys = Object.keys(next);
        if (
          prevKeys.length === nextKeys.length &&
          nextKeys.every((k) => prev[k] === next[k])
        ) {
          return prev;
        }
        return next;
      });
    };

    checkOverflow();

    const observer =
      typeof ResizeObserver !== "undefined" ? new ResizeObserver(checkOverflow) : null;
    if (observer) {
      Object.values(descRefs.current).forEach((el) => {
        if (el) observer.observe(el);
      });
    }
    window.addEventListener("resize", checkOverflow);

    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener("resize", checkOverflow);
    };
  }, [isOpen, release, visibleItems, expandedKey]);

  if (!isOpen || !release) return null;

  const handleClose = () => {
    onClose();
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
    if (listRef.current) {
      listRef.current.scrollTop = 0;
    }
  };

  const toggleItem = (key) => setExpandedKey((prev) => (prev === key ? null : key));

  return (
    <div className="whatsnew-overlay">
      <div className="whatsnew-modal" role="dialog" aria-modal="true" aria-labelledby="whatsnew-title">
        {/* Header */}
        <div className="whatsnew-header">
          <div className="whatsnew-icon-bg">
            <RocketIcon />
          </div>
          <div className="whatsnew-header-text">
            <h2 id="whatsnew-title">{t("What's New in SalesRoute")}</h2>
            <span>{t("New features, improvements and fixes to help you work smarter.")}</span>
          </div>
          <button type="button" className="whatsnew-close" onClick={handleClose} aria-label={t("Close")}>
            <CloseIcon />
          </button>
        </div>

        <div className="whatsnew-body">
          {/* Sidebar */}
          <nav className="whatsnew-sidebar" aria-label={t("Categories")}>
            <div className="whatsnew-sidebar-title">{t("Categories")}</div>
            <ul className="whatsnew-tabs">
              {TABS.map(({ key, label, Icon, tone }) => (
                <li key={key}>
                  <button
                    type="button"
                    className={`whatsnew-tab ${currentTab === key ? "is-active" : ""}`}
                    onClick={() => handleTabChange(key)}
                    aria-current={currentTab === key ? "true" : undefined}
                  >
                    <span className="whatsnew-tab-icon">
                      <Icon />
                    </span>
                    <span className="whatsnew-tab-label">{t(label)}</span>
                    <span className={`whatsnew-count whatsnew-count-${tone}`}>{counts[key]}</span>
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          {/* Main list */}
          <section className="whatsnew-main">
            <div className="whatsnew-main-head">
              <h3>{t(currentTabConfig.label)}</h3>
              <p>
                {currentTab === "all"
                  ? t("{{n}} updates across all categories", { n: visibleItems.length })
                  : t("{{n}} updates", { n: visibleItems.length })}
              </p>
            </div>

            <div className="whatsnew-list" ref={listRef}>
              {visibleItems.length === 0 && <div className="whatsnew-empty">{t("No updates in this release.")}</div>}

              {visibleItems.map((item) => {
                const isExpandable = Boolean(expandableKeys[item.key]);
                const isExpanded = isExpandable && expandedKey === item.key;
                return (
                  <div
                    className={`whatsnew-item ${isExpanded ? "is-expanded" : ""} ${isExpandable ? "is-expandable" : ""}`}
                    key={item.key}
                  >
                    <button
                      type="button"
                      className="whatsnew-item-toggle"
                      onClick={() => isExpandable && toggleItem(item.key)}
                      aria-expanded={isExpandable ? isExpanded : undefined}
                    >
                      <span className={`whatsnew-item-icon whatsnew-item-icon-${item.type}`}>
                        {item.image ? <img src={item.image} alt="" /> : <TypeIcon type={item.type} />}
                      </span>
                      <span className="whatsnew-item-content">
                        <span className="whatsnew-item-title-row">
                          <span className="whatsnew-item-title">{item.title}</span>
                          <span className={`whatsnew-badge whatsnew-badge-${item.type}`}>{t(BADGES[item.type])}</span>
                        </span>
                        {item.description && (
                          <span
                            ref={(el) => {
                              if (el) {
                                descRefs.current[item.key] = el;
                              } else {
                                delete descRefs.current[item.key];
                              }
                            }}
                            className="whatsnew-item-desc"
                          >
                            {item.description}
                          </span>
                        )}
                      </span>
                      {isExpandable && (
                        <span className="whatsnew-item-chevron">
                          <ChevronIcon />
                        </span>
                      )}
                    </button>
                  </div>
                );
              })}
            </div>
          </section>
        </div>

        {/* Footer */}
        <div className="whatsnew-footer">
          <div className="whatsnew-footer-note">
            <span className="whatsnew-footer-check">
              <CheckIcon size={12} strokeWidth={2} />
            </span>
            <span>{t("You're all caught up on the latest updates.")}</span>
          </div>
          <button type="button" className="gotit-button" onClick={handleClose}>
            {t("Got It")}
          </button>
        </div>
      </div>
    </div>
  );
};

NewInSalesroute.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  release: PropTypes.object,
};

export default NewInSalesroute;